export default {
	label(){
		return `<?xml version="1.0" encoding="utf-8"?>
<DieCutLabel Version="8.0" Units="twips">
\t<PaperOrientation>Landscape</PaperOrientation>
\t<Id>Small30333</Id>
\t<PaperName>30333 1/2 in x 1 in (2 up)</PaperName>
\t<DrawCommands>
\t\t<Path>
\t\t\t<FillMode>EvenOdd</FillMode>
\t\t\t<RoundRectangle X="0" Y="0" Width="720" Height="1440" Rx="180" Ry="180" />
\t\t\t<RoundRectangle X="720" Y="0" Width="720" Height="1440" Rx="180" Ry="180" />
\t\t</Path>
\t</DrawCommands>
\t<ObjectInfo>
\t\t<BarcodeObject>
\t\t\t<Name>BARCODE_1</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName></LinkedObjectName>
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<Text>e22b3732-b959-414a-af6d-d710e45e861b</Text>
\t\t\t<Type>QRCode</Type>
\t\t\t<Size>Small</Size>
\t\t\t<TextPosition>None</TextPosition>
\t\t\t<TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t<CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t<TextEmbedding>None</TextEmbedding>
\t\t\t<ECLevel>0</ECLevel>
\t\t\t<HorizontalAlignment>Center</HorizontalAlignment>
\t\t\t<QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
\t\t</BarcodeObject>
\t\t<Bounds X="134" Y="57" Width="1219" Height="562.5" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>PENDING_1</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName></LinkedObjectName>
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<HorizontalAlignment>Center</HorizontalAlignment>
\t\t\t<VerticalAlignment>Middle</VerticalAlignment>
\t\t\t<TextFitMode>ShrinkToFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String>12345</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="134" Y="1020.5" Width="1219" Height="120" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>LOT_1</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName></LinkedObjectName>
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<HorizontalAlignment>Center</HorizontalAlignment>
\t\t\t<VerticalAlignment>Middle</VerticalAlignment>
\t\t\t<TextFitMode>AlwaysFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String>123123123123123123</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="134" Y="750.5" Width="1219" Height="232.5" />
\t</ObjectInfo>
\t<ObjectInfo>
\t\t<TextObject>
\t\t\t<Name>TESTS_1</Name>
\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t<BackColor Alpha="0" Red="255" Green="255" Blue="255" />
\t\t\t<LinkedObjectName></LinkedObjectName>
\t\t\t<Rotation>Rotation0</Rotation>
\t\t\t<IsMirrored>False</IsMirrored>
\t\t\t<IsVariable>False</IsVariable>
\t\t\t<HorizontalAlignment>Center</HorizontalAlignment>
\t\t\t<VerticalAlignment>Middle</VerticalAlignment>
\t\t\t<TextFitMode>AlwaysFit</TextFitMode>
\t\t\t<UseFullFontHeight>True</UseFullFontHeight>
\t\t\t<Verticalized>False</Verticalized>
\t\t\t<StyledText>
\t\t\t\t<Element>
\t\t\t\t\t<String>123123123123123123</String>
\t\t\t\t\t<Attributes>
\t\t\t\t\t\t<Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
\t\t\t\t\t\t<ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
\t\t\t\t\t</Attributes>
\t\t\t\t</Element>
\t\t\t</StyledText>
\t\t</TextObject>
\t\t<Bounds X="134" Y="1238" Width="1219" Height="120" />
\t</ObjectInfo>
</DieCutLabel>`
	},
	keys(){
		return [
			"BARCODE_1",
			"LOT_1",
			"PENDING_1",
			"TESTS_1",
		]
	},
	format(sample){
		const sampleId = sample.id;
		const pending = sampleId.includes("PENDING-") ? sampleId.replace('PENDING-', '') : '  '
		const sampleTests = [...new Set(sample.required_tests.map(test => test.test_type))].join(' ');
		return {
			"BARCODE_1": sample.uuid,
			"LOT_1": sample.qa,
			"PENDING_1": pending,
			"TESTS_1": sampleTests
		}
	}
}
